import { FEATURE_SECTIONS } from "../../data/featuresContent";
import SectionViewAllLink from "./SectionViewAllLink";

const HomeFeaturesSection = ({ Reveal }) => (
  <section
    id="features"
    data-testid="features-section"
    className="relative py-28 md:py-36 scroll-mt-28"
    style={{ background: "var(--bg-alt)" }}
  >
    <div className="paper-overlay absolute inset-0 pointer-events-none" />
    <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span
              className="inline-block text-[11px] uppercase tracking-[0.25em] font-semibold mb-4"
              style={{ color: "var(--brand)" }}
            >
              Everything a reader needs
            </span>
            <h2
              className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.05]"
              style={{ color: "var(--text)" }}
            >
              Tools that feel like{" "}
              <span className="italic" style={{ color: "var(--brand)" }}>
                turning a page
              </span>
            </h2>
          </div>
          <SectionViewAllLink
            to="/features"
            label="Explore all features"
            testId="features-view-all-btn"
            className="hidden md:inline-flex shrink-0"
          />
        </div>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {FEATURE_SECTIONS.map((feature, i) => {
          const Icon = feature.icon;
          return (
            <Reveal key={feature.id} delay={i * 0.06}>
              <div
                data-testid={`feature-card-${i}`}
                className="cozy-card group rounded-3xl p-8 h-full"
              >
                <div
                  className="w-12 h-12 rounded-2xl flex items-center justify-center mb-6 transition-transform group-hover:rotate-[-4deg] group-hover:scale-110"
                  style={{ background: "var(--brand-tint)" }}
                >
                  <Icon
                    className="w-5 h-5"
                    style={{ color: "var(--brand)" }}
                    strokeWidth={2}
                  />
                </div>
                <h3
                  className="font-serif text-xl md:text-2xl font-medium mb-3"
                  style={{ color: "var(--text)" }}
                >
                  {feature.title}
                </h3>
                <p
                  className="text-sm leading-relaxed"
                  style={{ color: "var(--text-soft)" }}
                >
                  {feature.tagline}
                </p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal className="mt-10 md:hidden">
        <SectionViewAllLink
          to="/features"
          label="Explore all features"
          testId="features-view-all-btn-mobile"
          className="w-full justify-center"
        />
      </Reveal>
    </div>
  </section>
);

export default HomeFeaturesSection;
